import { render, staticRenderFns } from "./RecipientsBackup.vue?vue&type=template&id=f703e2fe"
import script from "./RecipientsBackup.vue?vue&type=script&lang=js"
export * from "./RecipientsBackup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports